import 'primeflex/primeflex.css';
import { useEffect, useState } from 'react';
import { LearningPathDto } from '../../general/dtos';
import { useApi } from '../../providers/api-provider';
import { LearningPathViewer } from '../learning-path-viewer';
import { GeneralInfoDialog } from '../dialogs/info-dialog';
import { Button } from 'primereact/button';

export default function UserLearningPath({ userKey }: { userKey?: string }) {
    const api = useApi();
    const [snapshot, setSnapshot] = useState<{ userKey: string; path: LearningPathDto } | null>(null);
    const [failure, setFailure] = useState<{ userKey: string; message: string } | null>(null);
    const [revision, setRevision] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 960);
    const [info, setInfo] = useState<{ title: string; message: string } | null>(null);

    useEffect(() => {
        const resize = () => setIsMobile(window.innerWidth <= 960);
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, []);

    useEffect(() => {
        let active = true;
        setSnapshot(null); setFailure(null); setInfo(null);
        if (api && userKey) {
            api.getUserTodoList(userKey).then(result => {
                if (!active) return;
                if ('message' in result) setFailure({ userKey, message: result.message });
                else setSnapshot({ userKey, path: result });
            }).catch(error => {
                if (active) setFailure({ userKey, message: error?.response?.data?.message || 'Could not load this user’s learning path.' });
            });
        }
        return () => { active = false; };
    }, [api, userKey, revision]);

    if (!userKey) return <p>Select one user to view their learning path.</p>;
    const path = snapshot?.userKey === userKey ? snapshot.path : null;
    const error = failure?.userKey === userKey ? failure.message : '';

    return <div style={{ minHeight: 0, overflowY: 'auto', flex: '1 1 auto' }}>
        {error ? <div role="alert">{error} <Button label="Retry" text onClick={() => setRevision(value => value + 1)} /></div>
            : <LearningPathViewer learningPath={path} loading={!path} enableViewButton
                isMobile={isMobile} isImpersonating showDashboard={false}
                onView={item => setInfo({ title: `View "${item.title}" clicked`, message: `This link opens the "${item.title}" lesson for the user to explore.` })} />}
        <GeneralInfoDialog visible={!!info} title={info?.title} message="" onClose={() => setInfo(null)}>
            <p>{info?.message}</p>
        </GeneralInfoDialog>
    </div>;
}
